import React from 'react'
import styled from 'styled-components'
import logo from '../images/logo-white.png'
import { Link } from 'react-router-dom';

const Container = styled.div`
    width: 90%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
`;

const ImageContainer = styled.div`
    max-width: 200px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 20px;
    padding-bottom: 20px;
    
`;

const Image = styled.img`
    max-width: 120px;
`;

function Navbar() {
    return (
        <Container>
            <ImageContainer>
                <Link to="/"><Image src={logo} id="top" /></Link>
            </ImageContainer>
        </Container>
    )
}

export default Navbar
